import { IBase } from '../base.interface';
import { IAccountCode } from './account-code.interface';
import { ICatalog } from './catalog.interface';
import { IConnector } from './connector.interface';
import { IIngredient } from './ingredient.interface';
import { IOption } from './option.interface';
import { IPack } from './pack.interface';
import { IProduct } from './product.interface';
import { IPromotion } from './promotion.interface';
import { IStep } from './step.interface';
import { ITag } from './tag.interface';
import { ITax } from './tax.interface';
import { IVariation } from './variation.interface';

export type OrderModePrice = {
  price: number;
  deliveryPrice: number;
  takeAwayPrice: number;
  onSpotPrice: number;
};

export interface ICatalogSnapshotData {
  catalog: ICatalog;
  products: IProduct[];
  packs: IPack[];
  promotions: IPromotion[];
  tags: ITag[];
  options: IOption[];
  variations: IVariation[];
  steps: IStep[];
  ingredients: IIngredient[];
  accountCodes: IAccountCode[];
  taxes: ITax[];
}

export interface ICatalogSnapshot extends IBase {
  name: string;
  startDate: Date;
  endDate: Date;

  publishedAt: string;

  connector: IConnector;

  catalogSnapshotToShops: ICatalogSnapshotToShop[];
}

export interface ICatalogSnapshotToShopProductVariationOverride {
  productVariationId: string;
  disabled: boolean | null;
  price: number | null;
  deliveryPrice: number | null;
  takeAwayPrice: number | null;
  onSpotPrice: number | null;
}

export interface ICatalogSnapshotToShopProductOverride {
  productId: string;
  disabled: boolean | null;
  productVariations: ICatalogSnapshotToShopProductVariationOverride[];
}

export interface ICatalogSnapshotToShopPackOverride {
  packId: string;
  disabled: boolean | null;
  price: number | null;
  deliveryPrice: number | null;
  takeAwayPrice: number | null;
  onSpotPrice: number | null;
}

export interface ICatalogSnapshotToShopPromotionOverride {
  promotionId: string;
  disabled: boolean | null;
}

export interface ICatalogSnapshotToShopData {
  productsOverrides: ICatalogSnapshotToShopProductOverride[];
  packsOverrides: ICatalogSnapshotToShopPackOverride[];
  promotionsOverrides: ICatalogSnapshotToShopPromotionOverride[];
}

export interface ICatalogSnapshotToShop extends IBase {
  shopId: string;
  catalogSnapshotId: string;
  catalogSnapshot: ICatalogSnapshot;

  data: ICatalogSnapshotToShopData;
}
